import React, { useEffect } from 'react';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { connectUserGroupsVM, UserGroupsContext } from './user-groups.context';
import { UserGroupsVM } from './user-groups.viewmodel';
import UserGroupsList from './_user-groups-list/user-groups-list';

interface IProps {
    vm: UserGroupsVM;
}

const UserGroupsContainer = ({ vm }: IProps) => {
    useEffect(() => {
        return () => {
            vm.willUnmount();
        };
    });

    return <UserGroupsList vm={vm} />;
};

const UserGroupsConnected = connectUserGroupsVM<IProps>(UserGroupsContainer, vm => ({ vm: vm }));

export const UserGroups = moduleHost(UserGroupsVM, UserGroupsContext, UserGroupsConnected);
